import React from 'react'
import { storiesOf } from '@storybook/react'
import GameTypeSelector from 'routes/SelectGameType/components/GameTypeSelector'

storiesOf('GameTypeSelector', module)
  .add('no friends', () => (
    <GameTypeSelector
      hasFriends
      createPublicGameUrl="/games/create?type=public"
      createPrivateGameUrl="/games/create?type=private"
      createClassicGameUrl="/games/create/classic"
    />
  ))
  .add('has friends', () => (
    <GameTypeSelector
      hasFriends={false}
      createPublicGameUrl="/games/create?type=public"
      createPrivateGameUrl="/games/create?type=private"
      createClassicGameUrl="/games/create/classic"
    />
  ))
  .add('without classic game', () => (
    <GameTypeSelector
      hasFriends
      createPublicGameUrl="/games/create?type=public"
      createPrivateGameUrl="/games/create?type=private"
    />
  ))
